import { TFunction } from "i18next";

import { MaterialConfig } from "fe-shared/src/types/domain";
import { CorrectionMaterial } from "../../../types";

import styles from "../CorrectionsDialog.module.scss";

export const getStuffGroupProps = (
  nonEligibleMaterials: MaterialConfig[] = []
) => ({
  name: "correction-stuff-types-checkbox-group",
  width: "100%",
  variants: nonEligibleMaterials.map((item) => ({
    id: item.code,
    title: item.name,
    value: item.code,
  })),
});

export const getCheckboxGroupProps = (tires: MaterialConfig[] = []) => ({
  name: "correction-material-types-checkbox-group",
  width: "100%",
  variants: tires.map(({ code, name }) => ({
    id: code,
    title: name,
    value: code,
  })),
});

export const getMaterialsCountConfig = (
  materialsByCode: {
    [key: string]: MaterialConfig;
  },
  materialsConfig: CorrectionMaterial[] = [],
  isTransactionWithTires = false
) =>
  materialsConfig.map(({ materialCode }, index) => ({
    valueKey: `materials[${index}].units.unitQuantity`,
    componentProps: {
      width: "102px",
      title: materialsByCode[materialCode]?.name,
      wrapperClassName: styles.tiresCountInput,
      mask: isTransactionWithTires ? "99999" : "999999999999",
    },
  }));

export const getScaleTicketsConfig = (
  scaleTickets: (string | number)[],
  t: TFunction
) => {
  return ["firstTicketNumber", "secondTicketNumber"].map((title, index) => ({
    valueKey: `scaleTickets[${index}].correctedTicketNumber`,
    componentProps: {
      width: "268px",
      title: t(`correction.dialog.inputs.${title}`),
      required: index === 0 || !!scaleTickets[index],
    },
  }));
};
